import React from 'react';
import {Form, Edit, Flex, List} from 'components';
import {useNamedSelector} from 'helpers';

export function DreamsInquiry2() {
  return (
    <Form {...useNamedSelector('identity.form', { name: 'dreams-inquiry-2' })}>
      <List tiny-gutter>
        <List.Title>Imagine that you have all the time, all the money, all the abilities and all the resources necessary to live your dreams.</List.Title>
        <List.Title>I would like to be:</List.Title>
        <Flex even stack>
          <Edit name="1" />
          <Edit name="2" />
          <Edit name="3" />
        </Flex>
        <List.Title>I would like to have:</List.Title>
        <Flex even stack>
          <Edit name="4" />
          <Edit name="5" />
          <Edit name="6" />
        </Flex>
        <List.Title>I would like to (do):</List.Title>
        <Flex even stack>
          <Edit name="7" />
          <Edit name="8" />
          <Edit name="9" />
        </Flex>
        <List.Title>Are you ready to commit to pursuing any or all of these dreams? When you are working with Goals Wizard and Action Wizard, you will be reminded of your dreams so that they come alive in your plans and actions.</List.Title>
      </List>
    </Form>
  );
}
